import React, { useState } from "react";
import { Box, Chip, IconButton, TableCell, TableRow } from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import LessMoreComp from "../../../../shared_elements/components/CustomLessMoreComp";

const StatusChip = ({ isActive }) => (
    <Chip
        label={isActive ? 'Active' : 'Inactive'}
        size="small"
        className={`status-chip ${isActive ? 'status-chip--active' : 'status-chip--inactive'}`}
    />
);

const ClassesList = ({ item }) => {
    const [open, setOpen] = useState(false);
    const hasSubclasses = item?.subclasses?.length > 0;

    return (
        <>
            <TableRow>
                <TableCell className="classes-list-arrow-col">
                    {hasSubclasses ? (
                        <IconButton size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
                        </IconButton>
                    ) : null}
                </TableCell>
                <TableCell><div className={`classes-list-name ${item?.name?.length > 50 ? 'is-long' : ''}`}><LessMoreComp name={item?.name || "--"} lessMr='name' /></div></TableCell>
                <TableCell>{item?.company_name || "--"}</TableCell>
                <TableCell><StatusChip isActive={item?.is_active} /></TableCell>
            </TableRow>
            {open && item.subclasses.map((sub) => (
                <TableRow key={sub?.id || sub?.slug} className="classes-list-subrow">
                    <TableCell className="classes-list-arrow-col" />
                    <TableCell>
                        <Box className="classes-list-sub-name">
                            <SubdirectoryArrowRightIcon className="classes-list-sub-icon" />
                            <div className={`classes-list-name is-sub ${sub?.name?.length > 50 ? 'is-long' : ''}`}><LessMoreComp name={sub?.name || "--"} lessMr='name' /></div>
                        </Box>
                    </TableCell>
                    <TableCell>{sub?.company_name || "--"}</TableCell>
                    <TableCell><StatusChip isActive={sub?.is_active} /></TableCell>
                </TableRow>
            ))}
        </>
    );
};

export default ClassesList
